import { useCallback } from "react";
import { t as translate } from "@/lib/i18n";

export function useTranslation(lang: string) {
  const t = useCallback(
    (key: string, params?: Record<string, string | number>) => translate(key, lang, params),
    [lang],
  );
  return { t };
}
